<app-error [error_message]="errorMessage" [error_type]="errorType"></app-error>
<form *ngIf="psForm && civiliteTab.length > 0"
    [formGroup]="psForm" novalidate #formDirective="ngForm" (ngSubmit)="addPS(psForm.value)">
    <div class='form-row my-row'>
        <div class='col-6 col-lg-auto pb-3 my-col'>
            
            <h4>
                {{ 'FORM.PS.TITLE-INFO' | translate }}
            </h4>

            <mat-form-field class="mx-2">
                <input matInput type="text" placeholder="{{ 'FORM.MAIL' | translate }}"
                formControlName="email" id="email">
                <mat-error *ngIf="hasError('email','required')">{{ "ERRORS.MAIL-REQUIRED" | translate }}</mat-error>
                <mat-error *ngIf="hasError('email', 'email')">{{ "ERRORS.MAIL-INVALID" | translate }}</mat-error>
                <mat-error *ngIf="hasError('email', 'pattern') && !hasError('email', 'email')">
                    {{ "ERRORS.MAIL-INVALID" | translate }}
                </mat-error>
            </mat-form-field>

            <mat-form-field class="mx-2">
                <mat-label>{{ "FORM.CIVILITE-SELECT" | translate }}</mat-label>
                <mat-select placeholder="{{ 'FORM.CIVILITE-SELECT' | translate }}" formControlName="civilite">
                    <mat-option value=""></mat-option>
                    <mat-option *ngFor="let civ of civiliteTab" [value]="civ.id">
                        {{ civ.libelle }}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field class="mx-2">
                <input matInput type="text" placeholder="{{ 'FORM.LNAME' | translate }}"
                formControlName="lname" id="lname">
            </mat-form-field>

            <mat-form-field class="mx-2">
                <input matInput type="text" placeholder="{{ 'FORM.FNAME' | translate }}"
                formControlName="fname" id="fname">
            </mat-form-field>

            <mat-form-field class="mx-2">
                <input matInput type="text" placeholder="{{ 'FORM.PHONE' | translate }}"
                formControlName="phoneNumber" id="phoneNumber">
                <mat-error *ngIf="hasError('phoneNumber','forbidden')">
                    {{ "ERRORS.PHONE-INVALID" | translate }}
                </mat-error>
            </mat-form-field>

            <mat-form-field class="mx-2">
                <mat-select [formControl]="clientMultiCtrl" placeholder="Clients" [multiple]="true" #multiSelect>
                    <mat-option>
                        <ngx-mat-select-search [formControl]="clientMultiFilterCtrl"
                                               placeholderLabel="{{ 'FORM.SELECT.CLIENT.SEARCH' | translate }}"
                                               noEntriesFoundLabel="{{ 'FORM.SELECT.CLIENT.NO-FOUND' | translate }}">
                        </ngx-mat-select-search>
                    </mat-option>
                    <mat-option *ngFor="let client of filteredClientsMulti | async" [value]="client">
                        {{client.name}}
                    </mat-option>
                </mat-select>
                <mat-error *ngIf="hasError('clients','required')">
                    {{ "ERRORS.CLIENT-REQUIRED" | translate }}
                </mat-error>
            </mat-form-field>
        </div>
    </div>

    <div class="form-row my-row">
        <div class='col-6 col-lg-auto pb-3 my-col'>
            <h4>
                {{ 'FORM.PS.TITLE-RESPONSABLE' | translate }}
            </h4>
            <mat-form-field class="mx-2">
                <mat-label>{{ 'FORM.SELECT.RESPONSABLE.LABEL' | translate}}</mat-label>
                <mat-select formControlName="responsable" placeholder="{{ 'FORM.SELECT.RESPONSABLE.LABEL' | translate}}">
                    <mat-option value="false">{{ 'FORM.SELECT.RESPONSABLE.NO' | translate }}</mat-option>
                    <mat-option value="true">{{ 'FORM.SELECT.RESPONSABLE.YES' | translate }}</mat-option>
                </mat-select>

                <mat-error *ngIf="hasError('responsable','required')">
                    {{ "ERRORS.RESPONSABLE-REQUIRED" | translate }}
                </mat-error>
            </mat-form-field>
        </div>
    </div>

    <ng-container *ngIf="psForm.value.responsable == 'true' || psForm.value.responsable == true">
        <div class="form-row my-row">
            <div class='col-6 col-lg-auto pb-1 my-col'>
                <mat-form-field class="mx-2">
                    <input matInput type="text" placeholder="{{ 'FORM.RES-EMAIL' | translate }}"
                    formControlName="res_email" id="res_email">
                    <mat-error *ngIf="hasError('res_email','required')">
                        {{ "ERRORS.RESPONSABLE-EMAIL-REQUIRED" | translate }}
                    </mat-error>
                    <mat-error *ngIf="hasError('res_email', 'pattern')">
                        {{ "ERRORS.MAIL-INVALID" | translate }}
                    </mat-error>
                </mat-form-field>
        
                <mat-form-field class="mx-2">
                    <input matInput type="text" placeholder="{{ 'FORM.RES-IDENTIFIANT' | translate }}"
                    formControlName="res_identifiant" id="res_identifiant">
                    <mat-error *ngIf="hasError('res_identifiant','required')">
                        {{ "ERRORS.RESPONSABLE-IDENTIFIANT-REQUIRED" | translate }}
                    </mat-error>
                </mat-form-field>
        
                <mat-form-field class="mx-2">
                    <input matInput type="text" placeholder="{{ 'FORM.RES-DESCRIPTION' | translate }}"
                    formControlName="res_description" id="res_description">
                    <mat-error *ngIf="hasError('res_description','required')">
                        {{ "ERRORS.RESPONSABLE-DESCRIPTION-REQUIRED" | translate }}
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
    </ng-container>

    <div class='form-row my-row'>
        <div class='col my-col'>
            <button type="submit" class="btn btn-primary mx-1" [disabled]="!psForm.valid">
                {{ "BUTTONS.ADD" | translate }}
            </button>
        </div>
    </div>
</form>
